import Link from '@mui/material/Link'
import { styled } from '@mui/material/styles'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'

import { rgbaStringToSolidHex } from './helper'

export interface TRoomSelectorProps {
  tabs: TTabData[]
  tabIndex: number
  onChange?: (label: string, index: number) => void
  fullWidth?: boolean
}

export interface TTabData {
  label: string
  to?: string
  icon?: React.ReactElement
  room?: string
}

const TabsThemed = styled((props) => {
  return <Tabs {...props} />
})((props) => {
  const { theme } = props

  return {
    overflow: 'inherit',
    background: 'transparent',
    border: 'none',
    minHeight: 'auto',
    height: '60px',
    textWrapStyle: 'balance',
    '& .MuiTabs-indicator': {
      display: 'none',
    },
    '& .overlap-left': {
      marginLeft: '-4px',
    },
    '& .overlap-both': {
      marginLeft: '-4px',
    },
    '& .Mui-selected, & .Mui-selected.MuiTab-fullWidth': {
      backgroundColor: rgbaStringToSolidHex(theme.palette.primary.shade10 || ''),
      border: `1px solid ${theme.palette.primary.dark}`,
      boxShadow: '0px 2px 3px 0px #bbbbbb',
      zIndex: 2,
      '& svg': {
        fill: theme.palette.success.light,
      },
    },
    '& svg': {
      fill: theme.palette.success.light,
    },
    '& .MuiTabs-scroller': {
      overflow: 'auto !important',
    },
  }
}) as typeof Tabs

const TabThemed = styled((props) => {
  return <Tab {...props} />
})((props) => {
  const { theme } = props

  return {
    backgroundColor: '#fff',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '4px',
    height: '40px',
    minHeight: '48px',
    minWidth: '200px',
  }
}) as typeof Tab

export const RoomSelector = ({ tabs, tabIndex, onChange, fullWidth = true }: TRoomSelectorProps) => {
  const handleChange = (ev: React.SyntheticEvent, newValue: number) => {
    if (onChange) {
      onChange(ev.currentTarget.textContent || '', newValue)
    }
  }

  const totalTabs = tabs.length - 1

  return (
    <TabsThemed value={tabIndex} onChange={handleChange} variant={fullWidth ? 'fullWidth' : 'standard'}>
      {tabs.map((t, idx) => {
        let overlap = ''
        if (tabIndex === idx) {
          const isLast = idx === totalTabs && tabIndex === totalTabs
          const isFirst = idx === 0 && tabIndex === 0
          overlap = `overlap-${isFirst ? 'right' : isLast ? 'left' : 'both'}`
        } else {
          if (idx === tabIndex + 1) {
            overlap = 'overlap-left'
          }
          if (idx === tabIndex - 1) {
            overlap = 'overlap-right'
          }
        }

        return (
          <TabThemed
            key={`${t.label}-${t.to}-${idx}`}
            component={Link}
            href={t.to}
            label={`${t.label} ${t.room || ''}`}
            icon={t.icon}
            iconPosition="start"
            className={overlap}
          />
        )
      })}
    </TabsThemed>
  )
}
